import { FeatureConfiguration } from "..";
import { reducer } from "features/stripe/reducers";
import { Stripe } from "./components/Stripe";

export default function (config: FeatureConfiguration) {
    config.reducers.stripe = reducer;

    config.addRoutes(config.routes.locationRoutes, [<Stripe key="stripe" />]);
}
